// src/components/editors/ObjectEditor.tsx
import { Checkbox, Label } from '@commenda/kakashi';
import { TSchemaObject } from '@commenda/types';

export const ObjectEditor = ({
  schemaObject,
  onChange,
  renderPropertiesTable,
  showAdditionalProperties = false,
}: {
  schemaObject: TSchemaObject;
  onChange: (n: TSchemaObject) => void;
  renderPropertiesTable: (
    childSchemaObject: TSchemaObject[],
    onListChange: (list: TSchemaObject[]) => void
  ) => React.ReactNode;
  showAdditionalProperties?: boolean;
}) => {
  return (
    <div className="ml-2 flex flex-col gap-2">
      {showAdditionalProperties && (
        <div className="flex gap-2 justify-end">
          <Checkbox
            checked={schemaObject.additionalProperties}
            onCheckedChange={(checked) =>
              onChange({
                ...schemaObject,
                additionalProperties: checked === true,
              })
            }
          />
          <Label>Allow Additional Properties</Label>
        </div>
      )}
      {renderPropertiesTable(schemaObject.properties ?? [], (list) =>
        onChange({ ...schemaObject, properties: list })
      )}
    </div>
  );
};
